/* eslint-disable camelcase */
export const repoId = process.env.REACT_APP_BAIKE_REPOSITORY_ID;

export enum PageType {
    entity = 'entity',
    faq = 'faq',
}
